import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { QuestionSetList } from './QuestionSetList';
import { QuestionSetEditor } from './QuestionSetEditor';
import { ROUTES } from '@/routes';

/**
 * Mode router for the Question Sets admin surface: the list lives at
 * ADMIN_QUESTION_SETS, and the same full-page editor is reused for both
 * ADMIN_QUESTION_SET_NEW (no :id) and ADMIN_QUESTION_SET_EDIT (:id present).
 */
export const AdminQuestionSets: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();
  const isNew = location.pathname === ROUTES.ADMIN_QUESTION_SET_NEW;

  if (isNew) return <QuestionSetEditor />;
  if (id) return <QuestionSetEditor id={id} />;
  return <QuestionSetList />;
};

export default AdminQuestionSets;
